var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStepperCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.999.09A7.91 7.91 0 1015.909 8 7.918 7.918 0 007.998.09z",
    fill: "#E95832"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.564 5.496l-4.512 6.122a.666.666 0 01-.942.124L3.888 9.166a.66.66 0 01.824-1.03l2.686 2.15 4.105-5.57a.659.659 0 111.06.78z",
    fill: "#fff"
  })));
}
export default __webpack_public_path__ + "static/media/stepper-checkmark.b5569197.svg";
export { SvgStepperCheckmark as ReactComponent };